/* global process */
let base = window._env_.VUE_APP_IMG_FLOW_HOST
export const getImgFlowProductTable = params => {
  return axios.get(`${base}/read_product_list`, {params})
}
export const getImgFlowProductDetail = params => {
  return axios.get(`${base}/read_product_detail/${params.id}`, {params})
}
// export const exportImgFlowProductData = params => {
//   return axios.get(`${base}/exportImgFlowProductData/${params.id}`, {params})
// }
// export const createImgFlowProductData = params => {
//   return axios.post(`${base}/createImgFlowProductData`, params)
// }
export const updateImgFlowProductData = params => {
  return axios.post(`${base}/update_product/change_alias/${params.id}`, params)
}
export const updateBatchImgFlowProductData = params => {
  return axios.post(`${base}/update_product/change_alias/batch`, params)
}
// export const deleteImgFlowProductData = params => {
//   return axios.post(`${base}/deleteImgFlowProductData/${params.id}`, params)
// }



// WEBPACK FOOTER //
// ./src/views/img-flow-product/img-flow-product.api.js